<div class="d-flex">
  <!-- Form -->
  <form (ngSubmit)="this.form.submit()" [formGroup]="this.form" class=" flex-grow-1">

    <div class="row">
      <div class="col-12">
        <app-alert-messages maximumNumberOfMessages="1"></app-alert-messages>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12">
        <h1 id="rrq-title"> RRQ </h1>

        <magieno-input-number-field
                [advancedFormControl]="this.form.formElements.employeesGrossPensionableSalary | asAdvancedFormControl"
                units="$"></magieno-input-number-field>

        <magieno-input-number-field
                [advancedFormControl]="this.form.formElements.numberOfPayPeriodsInTheYear | asAdvancedFormControl"></magieno-input-number-field>

        <magieno-input-number-field
                [advancedFormControl]="this.form.formElements.employeesQPPContributionsWithheld | asAdvancedFormControl"
                units="$"></magieno-input-number-field>

        <magieno-select
                [advancedFormControl]="this.form.formElements.year | asAdvancedFormControl"></magieno-select>
      </div>
    </div> <!-- / .row -->

    <br>
    <br>
    <br>
    <br>

    <!-- Button -->
    <div class="row fixed-bottom">
      <div class="col-12">
        <magieno-button [button]="this.form.getButton('SAVE')" id="saveCalculationButton"></magieno-button>

        <magieno-button [button]="this.form.getButton('EXECUTE')" id="executeCalculationButton"
                    style="margin-left: 12px"></magieno-button>

        <button (click)="openErrorsSidebar()" [class.bg-danger]="calculationStatusEnum === 'ERROR'"
                [class.bg-light]="calculationStatusEnum === 'CREATED'"
                [class.bg-success]="calculationStatusEnum === 'COMPLETED'"
                [class.bg-warning]="calculationStatusEnum === 'IN_PROGRESS'"
                class="badge rounded-pill ms-3"
                style="font-size: 12pt;"

        >{{ getStatusText() }}
        </button>

        <span style="margin-left: 15px;">Dernière sauvegarde: <strong>{{ getLastModifiedText() }}</strong></span>

      </div>
    </div>


  </form>

  <app-calculation-form-sidebar></app-calculation-form-sidebar>

</div>
